// extracted by mini-css-extract-plugin
module.exports = {"container":"TeacherMsg_container__qdrbn","msgImg":"TeacherMsg_msgImg__2wGIb","msgBlock":"TeacherMsg_msgBlock__3PH9T"};